import axiosClient from "./axiosClient";
import { unwrapApiResponse } from "./unwrapApiResponse";

export async function listQuoteRequests() {
  const { data } = await axiosClient.get("/api/admin/quote-requests");
  return unwrapApiResponse({ data });
}

export async function getQuoteRequest(id) {
  const { data } = await axiosClient.get(`/api/admin/quote-requests/${id}`);
  return unwrapApiResponse({ data });
}

export async function markQuoteRequestRead(id, isRead) {
  const { data } = await axiosClient.patch(
    `/api/admin/quote-requests/${id}/read`,
    { isRead }
  );
  return unwrapApiResponse({ data });
}

export async function deleteQuoteRequest(id) {
  const { data } = await axiosClient.delete(`/api/admin/quote-requests/${id}`);
  return unwrapApiResponse({ data });
}
